<template>
  <!-- MODAL Edit Bundle -->
  <div id="editBundleModal" class="col-12 justify-content-center" style="padding: 15vh 12%">
    <div class="col-12 m-0 p-0 section-container rounded-5 shadow">
      <!-- HEAD -->
      <div class="row overflow-hidden col-12 m-0 p-0 text-white rounded-top-5 pb-1 h-100 bg-lat1">
        <div class="col-6">
          <h6 class="lh-1 tx-left tx-white mb-2 ps-1 pt-2">
            <ion-icon name="cog" class="tx-18 me-2 align-bottom"></ion-icon>
            {{ dictionary['Editar conjunto'][session.user.language] + ": " + editBundleData.label }}
          </h6>
        </div>

        <button type="button" @click="saveBundle" id="btnSaveBundle"
          class="col-5 col-md-3 button-ok bg-primary border-white m-1 ms-auto pb-1 btn"
          style="max-height: 34px;">
          <span class="button-text text-white">
            <ion-icon name="create-outline"
              class="text-white p-0 m-auto tx-24 hydrated"></ion-icon>
            <span class="text-white m-auto">
              {{ dictionary['Guardar cambios'][session.user.language] }}
            </span>
          </span>
        </button>

        <div class="col-auto m-0 p-0 d-flex justify-content-end btn" @click="$emit('toggleEditBundleModal')">
          <ion-icon name="close" class="ms-auto tx-30 pt-1 pe-1 tx-white align-bottom"></ion-icon>
        </div>
      </div>

      <!-- CONTENT Edit Bundle -->
      <div class="m-0 p-0 w-100 rounded-bottom-5 pe-3 text-white" style="background-color: #03103e;">
        <div style="overflow: scroll; overflow-x: hidden; max-height: 60vh;">
          <div class="col-12 p-3 pe-0 pb-0">

            <!-- FORM Bundle -->
            <form class="row m-0 p-0 pe-3 overflow-hidden">
              <div class="col-md-6 col-12 m-0 p-0 ps-2 pe-2">
                <div class="form-group border rounded mb-3 col-md-12 col-12 m-0 p-0 d-flex flex-wrap">
                  <div class="row col-12 bg-lat1 text-white p-0 m-0 justify-content-around">
                    <div class="col-md-4 col-12 text-white p-1 m-0 rounded">
                      <label class="text-start ps-3 pt-1">
                        {{ dictionary['Conjunto'][session.user.language] }}</label>
                    </div>
                  </div>
                  <div class="row col-12 m-0 p-2 rounded-bottom">
                    <!-- NOMBRE -->
                    <div class="col-md-6 col-12 p-1 m-0">
                      <label class="col-12 p-0 pt-1 tx-14">
                        {{ dictionary['Nombre'][session.user.language] }}
                      </label>
                      <input v-model="editBundleData.label" id="inputEditBundleName" type="text"
                        v-on:change="dataHasChanged=true"
                        class="form-control form-control-line bg-white" style="color:black; min-width: 100px !important;">
                    </div>
                    <!-- PADRE -->
                    <div class="col-lg-6 col-md-6 col-12 p-1 m-0">
                      <label class="col-12 p-0 pt-1 tx-14">
                        {{ dictionary['Máquina'][session.user.language] }}
                      </label>
                      <select readonly disabled v-model="editBundleData.parent" id="selectNewBundleType"
                        v-on:change="dataHasChanged=true"
                        class="form-control form-control-line bg-white" style="color:black; height: 33.5px;">
                        <option v-for="machine in machineList" :key="machine.id" :value="machine.id">
                          {{ machine.label }}</option>
                      </select>
                    </div>

                  </div>
                  
                </div>

              </div>
              <!-- Variables -->
              <div class="form-group col-md-6 col-12 p-2 pt-0 pb-3 text-center">
                <div class="row col-12 border p-0 m-0 rounded pb-3">
                  <div class="row col-12 text-white bg-lat1 p-0 m-0 justify-content-around rounded">
                    <div class="col-md-4 col-12 text-white p-1 m-0 rounded">
                      <label class="text-start ps-3 pt-1" style="min-width: 160px;">
                        {{ dictionary['Variables'][session.user.language] }}</label>
                    </div>
                  </div>

                  <div class="row col-12 mt-1 p-2 ps-4 pe-4 m-0 rounded-5 justify-content-around">
                    <p class="text-white p-1 m-1 mb-0 ms-0 me-0 tx-14 border border-start-0 border-top-0 border-end-0">
                      {{ dictionary['Tipo numéricas'][session.user.language] }}</p>
                    <label class="col-12 p-0 pt-3 tx-14 tx-bold tx-clomos-dark" style="display:none;"
                      v-if="Object.keys(editBundleData.variables.analog)[0] != undefined">
                      {{ "ANA" }}
                    </label>

                    <div v-for="group in [0,1,2,3,4,5,6,7,8,9,10]" :key="group" class="d-flex w-100 flex-wrap justify-content-start m-0 p-0" 
                    :style="(analogByDistributionGroup.filter(v=> v.distributionGroup === group).length >= 1) ?'border-bottom: solid 1px white; padding-bottom: 0.5rem !important;' :'display: none;'">
                      <div v-for="variable in analogByDistributionGroup.filter(v=> v.distributionGroup === group)" :key="variable.dynamicVariableId"
                        class="col-4">
                        <div class="m-0 p-0 w-100 pt-1">
                          <label class="col-12 p-0 text-white tx-14">
                            {{ variable.label }}
                          </label>
                          <input v-model="editBundleData.variables.analog[variable.label].value"
                            v-on:change="variablesHasChanged=true"
                            :id="(variable.isConfiguration === 'false') ? ('editBundle' + variable.label) : 'inputEditBundle' + variable.label"
                            type="text" :disabled="variable.isConfiguration === 'false'"
                            :data-id="editBundleData.variables.analog[variable.label].variableId"
                            :data-type="editBundleData.variables.analog[variable.label].type"
                            class="inputEditBundle form-control form-control-line bg-white" style="color:black;">
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row col-12 mt-1 p-2 ps-4 pe-4 m-0 rounded-5 justify-content-around">
                    <p class="text-white p-1 m-1 mb-0 ms-0 me-0 tx-14 border border-start-0 border-top-0 border-end-0">
                      {{ dictionary['Tipo digitales'][session.user.language] }}
                    </p>

                    <label class="text-white tx-14 p-0 ps-2 pt-1" style="display:none;"
                      v-if="Object.keys(editBundleData.variables.digital)[0] != undefined">
                      {{ "DIG" }}
                    </label>

                    <div v-for="group in [0,1,2,3,4,5,6,7,8,9,10]" :key="group" class="d-flex w-100 flex-wrap justify-content-start m-0 p-0" 
                    :style="(digitalByDistributionGroup.filter(v=> v.distributionGroup === group).length >= 1) ?'border-bottom: solid 1px white; padding-bottom: 0.5rem !important;' :'display: none;'">
                      <div v-for="variable in digitalByDistributionGroup.filter(v=> v.distributionGroup === group)" :key="variable.dynamicVariableId"
                        class="col-4">
                        <div class="m-0 p-0 w-100 pt-1">
                          <label class="col-12 p-0 text-white tx-14">
                            {{ variable.label }}
                          </label>

                          <div
                            :class="variable.value"
                            :id="variable.isConfiguration === 'false'
                              ? 'editBundle' + variable.label
                              : 'inputEditBundle' + variable.label"
                            :data-id="variable.variableId"
                            :data-type="variable.type"
                            :data-value="variable.value"
                            class="inputEditBundle form-control form-control-line border-0 m-0 p-2 bg-white text-black tx-10"
                            @click="handleClick(variable)"
                          >
                            {{
                              dictionary?.[variable.value]?.[session.user.language] ?? ''
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row col-12 mt-1 p-2 ps-4 pe-4 m-0 rounded-5 justify-content-around">
                    <p
                      class="text-white p-1 m-1 mb-0 ms-0 me-0 tx-14 border border-start-0 border-top-0 border-end-0">
                      {{ dictionary['Tipo texto'][session.user.language] }}</p>
                    <label class="col-12 p-0 pt-3 tx-14 tx-bold tx-clomos-dark" style="display:none;"
                      v-if="Object.keys(editBundleData.variables.dynamic)[0] != undefined && Object.keys(editBundleData.variables.dynamic)[0] != 'configuracion'">
                      {{ "DIN" }}
                    </label>


                    <div v-for="group in [0,1,2,3,4,5,6,7,8,9,10]" :key="group" class="d-flex w-100 flex-wrap justify-content-start m-0 p-0" 
                    :style="(dynamicByDistributionGroup.filter(v=> v.distributionGroup === group).length >= 1) ?'border-bottom: solid 1px white; padding-bottom: 0.5rem !important;' :'display: none;'">
                      <div v-for="variable in dynamicByDistributionGroup.filter(v=> v.distributionGroup === group)" :key="variable.dynamicVariableId"
                        class="col-4">
                        <div class="m-0 p-0 w-100 pt-1">
                          <label class="col-12 p-0 text-white tx-14">
                            {{ variable.label }}
                          </label>
                          <input v-model="editBundleData.variables.dynamic[variable.label].value"
                            v-on:change="variablesHasChanged=true"
                            :id="(variable.isConfiguration === 'false') ? ('editBundle' + variable.label) : 'inputEditBundle' + variable.label"
                            type="text" :disabled="variable.isConfiguration === 'false'"
                            :data-id="editBundleData.variables.dynamic[variable.label].variableId"
                            :data-type="editBundleData.variables.dynamic[variable.label].type"
                            class="inputEditBundle form-control form-control-line bg-white" style="color:black;">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import $ from 'jquery';
import Leaflet from 'leaflet';
// Clomos
import api from '@/services/api';

export default {
  name: "EditBundleModal",
  props: {
    session: {
      type: Object,
      required: true,
    },
    dictionary: {
      type: Object,
      required: true,
    },
    countries: {
      type: Object,
      required: true,
    },
    timeZones: {
      type: Object,
      required: true,
    },
    currentCompany: {
      type: Object,
      required: true,
    },
    bundleId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      editBundleData: {
        id: "",
        nifCif: "",
        dataConsumed: "",
        label: "",
        dclId: "",
        dclTypeId: "",
        dclClass: "",
        type: "",
        distributionGroup: "",
        parent: "",
        isBase: "",
        isPublic: 0,
        token: "",
        imgSrc: "",
        machine: "",
        fechaUltimaComunicacion: "",
        tieneAlarmaActivada: "",
        version: "",
        geoJSON: {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [0, 0]
          }
        },
        variables: {
          analog: {},
          digital: {},
          dynamic: {},
        }
      },
      bundleConfigurationForm: {
        id: "",
        variableId: "",
        value: ""
      },
      machineList: [],
      bundleMap: undefined,
      bundleMarker: undefined,
      bundleImageForm: {
        id: this.bundleId,
        variableId: "",
        nifCif: "",
        src: "",
        file: "",
        oldFileName: ""
      },
      bundleBlueprintForm: {
        id: this.bundleId,
        variableId: "",
        nifCif: "",
        src: "",
        file: "",
        oldFileName: ""
      },
      dataHasChanged: false,
      variablesHasChanged: false,
    }
  },
  emits: ["toggleEditBundleModal"],
  computed: {
    analogByDistributionGroup() {
      const variablesArray = Object.values(this.editBundleData.variables.analog)
        .map(v => ({
          ...v,
          distributionGroup: parseInt(v.distributionGroup, 10) || 0
        }))
        .filter(v => v.isConfiguration === 'true')
      variablesArray.sort((a, b) => a.distributionGroup - b.distributionGroup);
      return variablesArray;
    },
    digitalByDistributionGroup() {
      const variablesArray = Object.values(this.editBundleData.variables.digital)
        .map(v => ({
          ...v,
          distributionGroup: parseInt(v.distributionGroup, 10) || 0
        }))
        .filter(v => v.isConfiguration === 'true')
      variablesArray.sort((a, b) => a.distributionGroup - b.distributionGroup);
      return variablesArray;
    },
    dynamicByDistributionGroup() {
      const variablesArray = Object.values(this.editBundleData.variables.dynamic)
        .map(v => ({
          ...v,
          distributionGroup: parseInt(v.distributionGroup, 10) || 0
        }))
        .filter(v => v.isConfiguration === 'true')
      variablesArray.sort((a, b) => a.distributionGroup - b.distributionGroup);
      return variablesArray;
    }
  },
  methods: {
    handleClick(variable) {
      if (variable.isConfiguration === 'false') {
        return;
      }
    this.variablesHasChanged=true
      const currentValue = this.editBundleData.variables.digital[variable.label].value;
      this.editBundleData.variables.digital[variable.label].value = currentValue === 'true' ? 'false' : 'true';
    },
    //DISPLAY
    displayImage(src) {
      if (src != undefined && src != '') {
        try {
          return this.$clientConfig.api + '/ficheros/ficheros.php?fichero=' + src + '&identificadorusuario=' + this.session.user.id + '&Token=' + localStorage.getItem("ClomosAuthToken");
        }
        catch (e) {
          console.warn(e);
        }
      }
      return require('@/assets/img/placeholder_image.jpg');
    },
    displayBlueprint() {
      let src = "";
      if (this.editBundleData.variables != undefined
        && this.editBundleData.variables.dynamic != undefined
        && this.editBundleData.variables.dynamic.urlPlano != undefined)
        src = this.editBundleData.variables.dynamic.urlPlano.value;
      if (src != undefined && src != '') {
        try {
          return this.$clientConfig.api + '/ficheros/ficheros.php?fichero=' + src + '&identificadorusuario=' + this.session.user.id + '&Token=' + localStorage.getItem("ClomosAuthToken");
        }
        catch (e) {
          console.warn(e);
        }
      }
      return require('@/assets/img/placeholder_image.jpg');
    },
    displayEditBundleImageThumbnail(file) {
      if (file === '' || file === undefined) return "";
      let fileSrc = URL.createObjectURL(file);
      setTimeout(() => {
        URL.revokeObjectURL(fileSrc);
      }, 1000);
      return fileSrc;
    },
    onChangeEditBundleImage(event) {
      if (event.target.files[0] != undefined && event.target.files[0].size > 2097152) {
        this.onRemoveEditBundleImage()
        alert("El tamaño del fichero debe ser inferior a 2Mb.");
        return;
      }
      if ((event.target.files[0]?.name ||"") != "") {
        this.onRemoveEditBundleImage()
        alert("Ningún fichero seleccionado.");
        return;
      }
      this.bundleImageForm.nifCif = this.editBundleData.nifCif;
      this.bundleImageForm.file = event.target.files[0];
      this.bundleImageForm.src = event.target.files[0].name;
      this.bundleImageForm.name = event.target.files[0].name;
      this.bundleImageForm.oldFileName = ""+this.editBundleData.imgSrc;
    },
    onRemoveEditBundleImage() {
      $("#bundleImageUploadSrc").get()[0].value = "";
      this.bundleImageForm.nifCif = "";
      this.bundleImageForm.file = "";
      this.bundleImageForm.src = "";
      this.bundleImageForm.name = "";
      this.bundleImageForm.oldFileName = ""+this.bundleImageForm.imgSrc;
    },
    displayEditBundleBlueprintThumbnail(file) {
      if (file === '' || file === undefined) return "";
      let fileSrc = URL.createObjectURL(file);
      setTimeout(() => {
        URL.revokeObjectURL(fileSrc);
      }, 1000);
      return fileSrc;
    },
    onChangeEditBundleBlueprint(event) {
      if (event.target.files[0] != undefined && event.target.files[0].size > 2097152) {
        this.onRemoveEditBundleBlueprint()
        alert("El tamaño del fichero debe ser inferior a 2Mb.");
        return;
      }
      if ((event.target.files[0]?.name ||"") != "") {
        this.onRemoveEditBundleBlueprint()
        alert("Ningún fichero seleccionado.");
        return;
      }
      this.bundleBlueprintForm.nifCif = this.editBundleData.nifCif;
      this.bundleBlueprintForm.file = event.target.files[0];
      this.bundleBlueprintForm.src = event.target.files[0].name;
      this.bundleBlueprintForm.name = event.target.files[0].name;
      this.bundleBlueprintForm.oldFileName = ""+this.editBundleData.variables?.dynamic?.urlPlano?.value
    },
    onRemoveEditBundleBlueprint() {
      $("#machineBlueprintUploadSrc").get()[0].value = "";
      this.bundleBlueprintForm.nifCif = "";
      this.bundleBlueprintForm.file = "";
      this.bundleBlueprintForm.src = "";
      this.bundleBlueprintForm.name = this.editBundleData.variables?.dynamic?.urlPlano?.value
      this.bundleBlueprintForm.oldFileName = "";
    },
    onPositionChanged() {
      if (this.$route.params.currentDisplay === 'commandCenters') {
        this.bundleMap.removeLayer(this.bundleMarker);
        this.bundleMarker = Leaflet.marker([this.editBundleData.geoJSON.geometry.coordinates[0], this.editBundleData.geoJSON.geometry.coordinates[1]]).addTo(this.bundleMap);
        this.displayBundleMap()
      }
    },
    // SET
    async saveBundle() {
      if (this.dataHasChanged === true) await this.setEditBundleData();
      if (this.variablesHasChanged === true) await this.setBundleVariables();
    },
    displayBundleMap() {
      if (this.bundleMap != undefined) {
        this.bundleMap.invalidateSize();
        this.bundleMap.remove();
      }
      var bundleMap = Leaflet.map("bundleMapContent");
      Leaflet.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png?lang=' + this.session.user.language, { maxZoom: 19 }).addTo(bundleMap);
      bundleMap.on('click', this.onSetNewCoordinates)

      this.bundleMap = bundleMap;

      let bundleMapListForGroup = [];
      if ($(".leaflet-control-attribution").get()[0] != undefined) $(".leaflet-control-attribution").get()[0].remove();
      var bundleMarker = Leaflet.marker([this.editBundleData.geoJSON.geometry.coordinates[0], this.editBundleData.geoJSON.geometry.coordinates[1]]);
      bundleMarker.addTo(bundleMap);
      bundleMapListForGroup.push(bundleMarker);
      var bundleMapGroup = Leaflet.featureGroup(bundleMapListForGroup);
      this.bundleMap.fitBounds(bundleMapGroup.getBounds());

      this.bundleMarker = bundleMarker;
    },
    onSetNewCoordinates(event) {
      this.editBundleData.geoJSON = {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [Number(event.latlng.lat), Number(event.latlng.lng)]
        }
      }
      this.bundleMap.removeLayer(this.bundleMarker);
      this.bundleMarker = Leaflet.marker([this.editBundleData.geoJSON.geometry.coordinates[0], this.editBundleData.geoJSON.geometry.coordinates[1]]).addTo(this.bundleMap);
    },
    async setEditBundleData() {
      let response = await api.setBundleData(this.editBundleData);
      if (response["status-code"] === "200") {
        window.alert("El conjunto ha sido modificado satisfactoriamente.");
      }
      else {
        window.alert("Error al modificar el conjunto.");
      }
      this.getEditBundleData();
    },
    async setBundleVariables() {
      let variablesData = {
        bundleId: this.editBundleData.id
      };
      $(".inputEditBundle").get().forEach(input => {
        let variableLabel = input.id.replace("inputEditBundle", "");
        let ic = false;
        if (this.editBundleData.variables.analog[variableLabel] != undefined
          && this.editBundleData.variables.analog[variableLabel].isConfiguration === "true")
          ic = true;
        if (this.editBundleData.variables.digital[variableLabel] != undefined
          && this.editBundleData.variables.digital[variableLabel].isConfiguration === "true")
          ic = true;
        if (this.editBundleData.variables.dynamic[variableLabel] != undefined
          && this.editBundleData.variables.dynamic[variableLabel].isConfiguration === "true")
          ic = true;
        if (ic) {
          variablesData[variableLabel] = {
            value: (input.getAttribute("data-type") === "0")
              ? (input.getAttribute("data-value") === "true")
                ? 1
                : 0
              : input.value,
            id: input.getAttribute("data-id"),
            type: input.getAttribute("data-type")
          }
        }
      });
      let response = await api.setBundleVariables(variablesData);
      if (response["status-code"] === "200") {
        window.alert("El conjunto ha sido modificado satisfactoriamente.");
      }
      else {
        window.alert("Error al modificar el conjunto.");
      }
      this.getEditBundleData();
    },
    async setBundleConfiguration() {
      let response = await api.setBundleConfiguration(this.bundleConfigurationForm);
      if (response["status-code"] === "200") {
        window.alert("Las variables han sido modificado satisfactoriamente.");
      }
      else {
        window.alert("Error al modificar el conjunto.");
      }
      this.getEditBundleData();
    },
    async setEditBundleImage() {
      let response = await api.setBundleImage(this.bundleImageForm);
      console.log(response);
      this.onRemoveEditBundleImage();
      this.getEditBundleData();
    },
    async setEditBundleBlueprint() {
      if (this.editBundleData.variables != undefined
        && this.editBundleData.variables.dynamic != undefined
        && this.editBundleData.variables.dynamic.urlPlano)
        this.bundleBlueprintForm.variableId = this.editBundleData.variables.dynamic.urlPlano.variableId;
      let response = await api.setBundleBlueprint(this.bundleBlueprintForm);
      console.log(response);
      this.onRemoveEditBundleImage();
      this.getEditBundleData();
    },
    // GET 
    async getEditBundleData(callback) {
      let response = await api.getBundleData(this.bundleId);
      this.editBundleData = api.parseBundleFromResponse(response);
      if (this.editBundleData.variables.dynamic['configuracion'] != undefined)
        this.bundleConfigurationForm = {
          id: this.editBundleData.id,
          variableId: this.editBundleData.variables.dynamic['configuracion'].variableId,
          value: this.editBundleData.variables.dynamic['configuracion'].value
        }
      else
        this.bundleConfigurationForm = {
          id: this.editBundleData.id,
          variableId: "",
          value: ""
        }
      this.dataHasChanged = false;
      this.variablesHasChanged = false;
      if (callback && typeof callback === "function") callback(this.bundleData);
    },
    async getMachineList() {
      let request = {
        nifCif: this.currentCompany.nifCif,
        limit: 0,
        offset: 0,
        where: "",
      };
      let response = await api.getMachineListByCompany(request);
      for (let i in response.maquinas) [
        this.machineList[i] = {
          id: response.maquinas[i].idDcl,
          label: response.maquinas[i].etiqueta,
        }
      ]
    }
  },
  async created() {
    await this.getEditBundleData();
    await this.getMachineList();
    if (this.$route.params.currentDisplay === 'commandCenters')
      setTimeout(() => { this.displayBundleMap() }, 300);
  }
}
</script>

<style>
#editBundleModal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100vw;
  height: 100vh;
}

@media (max-width: 767px) {
  #bundleImageUploadFormContainer {
    flex-direction: column;
  }

  #bundleBlueprintUploadFormContainer {
    flex-direction: column;
  }
}
</style>